<template>
  <star-condition-layout
    ref="starCondition"
    :onSearch="handleSearch"
    :onReset="reset"
    :loading="loading"
  >
    <star-condition-cell label="模版名称">
      <a-input v-model="searchCondition.templateName" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="模版状态">
      <a-select v-model="searchCondition.enabled" :style="{ width: '100%' }" allowClear>
        <a-select-option :value="0">启用 </a-select-option>
        <a-select-option :value="1">停用 </a-select-option>
      </a-select>
    </star-condition-cell>
  </star-condition-layout>
</template>

<script>
export default {
  components: {},
  props: {
    onSearch: {
      type: Function,
      required: true
    },
    loading: Boolean
  },
  data() {
    return {
      searchCondition: {
        templateName: undefined,
        enabled: undefined
      }
    }
  },

  mounted() {},

  methods: {
    reset() {
      this.searchCondition = {
        templateName: undefined,
        enabled: undefined
      }
      this.handleSearch()
    },

    handleSearch() {
      this.onSearch(this.searchCondition)
    }
  }
}
</script>
